var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconappointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_285_2061)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.0444,
    y: 13.5439,
    width: 80,
    height: 80,
    rx: 15,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4819 40.4189V36.6689M49.6069 40.4189V36.6689M41.6382 46.0439H74.4507M41.1694 49.8764C41.1694 45.9108 41.1694 43.9271 41.9869 42.4121C42.7261 41.0608 43.8732 39.9774 45.2644 39.3164C46.8694 38.5439 48.9694 38.5439 53.1694 38.5439H62.9194C67.1194 38.5439 69.2194 38.5439 70.8244 39.3164C72.2363 39.9952 73.3819 41.0789 74.1019 42.4102C74.9194 43.9289 74.9194 45.9127 74.9194 49.8783V59.0883C74.9194 63.0539 74.9194 65.0377 74.1019 66.5527C73.3627 67.904 72.2157 68.9874 70.8244 69.6483C69.2194 70.4189 67.1194 70.4189 62.9194 70.4189H53.1694C48.9694 70.4189 46.8694 70.4189 45.2644 69.6464C43.8735 68.986 42.7265 67.9033 41.9869 66.5527C41.1694 65.0339 41.1694 63.0502 41.1694 59.0846V49.8764Z",
    stroke: "#29A63E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_285_2061",
    x: 0.823599,
    y: 0.915333,
    width: 114.442,
    height: 114.442,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.59222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.61042
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.847059 0 0 0 0 0.823529 0 0 0 0 0.988235 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_285_2061"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_285_2061",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconappointment);
export default __webpack_public_path__ + "static/media/Iconappointment.80d831fc28152ed5b2dbd4ea482ca2b9.svg";
export { ForwardRef as ReactComponent };